import React, { Component } from "react";
import { leadType } from "../../app";
import FormStep from "../../common/components/formStep";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import BankChargeAgree from "../../common/components/pageBlocks/loanDetails/bankChargeAgree";
import LoanDetailsForm from "../../common/components/pageBlocks/loanDetails/loanDetailsForm";
import LoanSummary from "../../common/components/pageBlocks/loanDetails/loanSummary";
import VehicleUpdateCard from "../../common/components/pageBlocks/vehicleUpdateCard";
import commonContext, { AppContext } from "../../common/context/common";
import { Utilities } from "../../common/utils/utilities";
import { Zd10SecApis } from "../apis/zd10SecApis";

interface IProps {
    history: any;
}
interface IState {}
export default class LoanDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Zd10SecApis;
    setLead: Function;
    utils: Utilities;
    steps = [
        { title: "Vehicle" },
        { title: "Loan", active: true },
        { title: "Review" },
        { title: "Personal" },
        { title: "Confirmation" },
    ];
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        const finalCarPrice: number =
            this.lead.avgCost -
            (this.lead.discountPrice ? parseFloat(this.lead.discountPrice) : 0);
        if (this.lead.amountPayable) {
            return;
        }
        let desiredLoanAmount: number = this.utils.getFinalPrice(
            this.lead.tenure,
            this.lead.upto36m,
            this.lead.M37_60,
            this.lead.M61_84,
            (finalCarPrice as unknown) as string,
            this.lead.loanAmt
        );
        const apiDataServ = await this.apis.getSarvSurakshaPremium({
            ...this.lead,
            tenure: (this.lead.tenure as unknown) as number,
        });
        const apisDatagetStampDuty = await this.apis.getStampDuty({
            ...this.lead,
            tenure: (this.lead.tenure as unknown) as number,
            loanAmount: desiredLoanAmount,
            type: "sd",
        });
        const emi = this.utils.getEmi(
            this.lead.interestRate,
            desiredLoanAmount,
            this.lead.tenure
        );
        let totalLoanAmount: number =
            desiredLoanAmount +
            (this.lead.roadTaxInsuranceAvailed
                ? parseFloat(this.lead.rtoEditAmount)
                : 0) +
            (this.lead.motorInsuranceAvailed
                ? parseFloat(this.lead.motorInsurancePremium)
                : 0) +
            (this.lead.dealerInsuranceAvailed
                ? parseFloat(this.lead.dealerInsuranceAmtEdit)
                : 0) +
            apiDataServ.result?.premium;
        let totalAmount: number =
            totalLoanAmount -
            (apisDatagetStampDuty?.result
                ? apisDatagetStampDuty.result?.stampDuty
                : 0) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges -
            (this.lead.motorInsuranceAvailed
                ? parseFloat(this.lead.motorInsurancePremium)
                : 0) -
            apiDataServ.result?.premium;
        let marginMoneyPaid = finalCarPrice - desiredLoanAmount;

        this.setLead({
            desiredLoanAmount,
            desiredLoanAmountUpTo: desiredLoanAmount,
            loanAmtSelectedByUser: desiredLoanAmount,
            insuranceSsiPremium: apiDataServ.result?.premium,
            stampDuty: apisDatagetStampDuty.result
                ? apisDatagetStampDuty?.result?.stampDuty
                : 0,
            emi,
            finalCarPrice,
            totalLoanAmount,
            totalAmount,
            marginMoneyPaid,
            liLoanAmount: desiredLoanAmount,
            liTenure: this.lead.liTenure
                ? this.lead.liTenure
                : this.lead.tenure,
            liEMI: this.lead.emi,
            liInterestRate: this.lead.interestRate,
            liPurposeLoan: "Personal",
            preApprovedLoanAmt: this.lead.loanAmt,
            insuranceName: "servSuraksha",
            insuranceAvailed: parseFloat(this.lead.tenure) > 60 ? false : true,
        });
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;

        if (!this.lead.LDIAgree) {
            return "";
        }

        const apiData = await this.apis.updateLoanInfo({
            ...this.lead,
            liTenure: (this.lead.liTenure as unknown) as string,
        });

        this.props.history.push("/review");
    };

    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <VehicleUpdateCard />
                                <LoanDetailsForm />
                                <LoanSummary />
                                <BankChargeAgree />
                                <BackContinueButton backPath="/vehicle-details" />
                            </div>
                        </form>
                    </section>
                </div>
            </>
        );
    }
}
